import React from "react";
import * as moment from "moment-timezone";
import { toCamelCase } from "../../../../hooks/toCameCase.tsx";
import { ReporteChequeo, ReporteRow } from "../../../../models/ReporteChequeo";
import { operationalDayKeyForVisitRow } from "../../../../utils/operationalDayReporteChequeo.ts";
import type { BranchReportMeta } from "../../../../utils/payrollBranchMeta.ts";
import {
  calcularTiempoTrabajado,
  calcularTurno,
} from "../../../../interfaces/formik/IReporteRelojChecador.ts";
import { useDispatch } from "react-redux";
import {
  setCurrentState,
  setShow,
} from "../../../../store/slices/reportClockSlice.ts";
import {
  reporteChequeoTableUi as S,
  reporteChequeoDataRowHover,
  formatReporteChequeoDate,
} from "./reporteChequeoTableUi.ts";

const RowReporteChequeo = ({
  record,
  payrollBranchMeta,
  allChecks = [],
}: {
  record: ReporteRow;
  payrollBranchMeta?: Record<number, BranchReportMeta>;
  allChecks?: ReporteChequeo[];
}) => {
  const dispatch = useDispatch();
  const [hovered, setHovered] = React.useState(false);
  const calculatedShift = calcularTurno(
    record.checkIn?.assistanceCheck_checkTime ?? ""
  );
  const registeredShift = record.checkIn?.candidate_shift_name;
  const isNocturno = String(registeredShift || "")
    .trim()
    .toLowerCase() === "nocturno";

  const operationalDay =
    operationalDayKeyForVisitRow(record, payrollBranchMeta, allChecks) ||
    moment
      .utc(record.checkIn?.assistanceCheck_checkDate)
      .format("YYYY-MM-DD");

  const handleClick = () => {
    dispatch(setShow(true));
    dispatch(
      setCurrentState({
        partner: record.checkIn?.partner_id,
        branch: record.checkIn?.branch_id,
        day: operationalDay,
      })
    );
  };

  const rowBg = hovered ? reporteChequeoDataRowHover : "#ffffff";
  const cellStyle = { ...S.td, background: rowBg };

  const hoursWorked = calcularTiempoTrabajado(
    record.checkIn?.assistanceCheck_checkTime!,
    record.checkOut?.assistanceCheck_checkTime
  );

  return (
    <tr
      style={S.dataRow}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <td style={{ ...cellStyle, ...S.tdPartner }}>
        <div style={S.partnerName}>
          {toCamelCase(
            `${record.checkIn?.person_firstName} ${record.checkIn?.person_lastName} ${record.checkIn?.person_secondLastName}`
          )}
          {isNocturno && (
            <i
              className="fa-solid fa-moon ms-1"
              style={{ color: "#64748b" }}
              title="Este colaborador tiene turno Nocturno registrado en RH"
            />
          )}
        </div>
      </td>
      <td style={{ ...cellStyle, ...S.tdPosition }}>
        {record.checkIn?.position_name}
      </td>
      <td style={{ ...cellStyle, ...S.tdCenter }}>{calculatedShift}</td>
      <td style={{ ...cellStyle, ...S.tdCenter }}>
        {formatReporteChequeoDate(
          operationalDayKeyForVisitRow(record, payrollBranchMeta, allChecks) ||
            record.checkIn?.assistanceCheck_checkDate ||
            ""
        )}
      </td>
      <td style={{ ...cellStyle, ...S.tdNumeric }}>
        {record.checkIn?.assistanceCheck_checkTime}
      </td>
      <td style={{ ...cellStyle, ...S.tdNumeric }}>
        {record.checkOut?.assistanceCheck_checkTime ?? "—"}
      </td>
      <td style={{ ...cellStyle, ...S.tdHours }}>{hoursWorked}</td>
      <td style={{ ...cellStyle, ...S.tdCenter }}>{record.checkIn?.branch_name}</td>
      <td style={{ ...cellStyle, ...S.tdCenter }}>
        <button
          type="button"
          style={S.actionBtn}
          onClick={() => handleClick()}
          title="Ver detalle del registro"
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-1px)";
            e.currentTarget.style.boxShadow =
              "0 4px 12px rgba(247, 185, 23, 0.45)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow =
              "0 2px 8px rgba(247, 185, 23, 0.4)";
          }}
        >
          <i className="fa fa-eye" />
        </button>
      </td>
    </tr>
  );
};

export default RowReporteChequeo;
